import { setLoader } from './loader-action'
import getPayeService from '../../api/envService'
import { MONGO_LOGGER_ENDPOINT, MONGO_LOGGER_ENABLED_ENDPOINT } from '../../api/endpoints'
import { SET_MONGO_LOGGER } from '../reducers/mongo-logger-reducer'
import { showAlert } from './alert-action'
import { completeUrl, downloadFile } from '../../api/paye-service-api'

function setMongoLogger(value) {
  return { type: SET_MONGO_LOGGER, value }
}

export const getMongoLogger = () => dispatch => {
  dispatch(setLoader(true))
  return getPayeService()
    .get(MONGO_LOGGER_ENDPOINT)
    .then(response => dispatch(setMongoLogger(response)))
    .catch(err => console.log(err))
    .finally(() => dispatch(setLoader(false)))
}

/** Appel léger vers /enabled — sans loader, pour polling */
export const getMongoLoggerEnabled = () => dispatch => {
  return getPayeService()
    .get(MONGO_LOGGER_ENABLED_ENDPOINT)
    .then(response => dispatch(setMongoLogger({ enabled: response.enabled })))
    .catch(err => console.log(err))
}

export const updateMongoLogger = enabled => dispatch => {
  dispatch(setLoader(true))
  return getPayeService()
    .put(MONGO_LOGGER_ENDPOINT, { enabled })
    .then(response => dispatch(setMongoLogger(response)))
    .then(() =>
      dispatch(showAlert('success', enabled ? 'Logs détaillés MongoDB activés' : 'Logs détaillés MongoDB désactivés'))
    )
    .catch(err => console.log(err))
    .finally(() => dispatch(setLoader(false)))
}

export const updateMongoLoggerThreshold = thresholdMs => dispatch => {
  dispatch(setLoader(true))
  return getPayeService()
    .put(MONGO_LOGGER_ENDPOINT, { thresholdMs }, 'threshold')
    .then(response => dispatch(setMongoLogger(response)))
    .then(() => dispatch(showAlert('success', `Seuil slow-query mis à jour : ${thresholdMs}ms`)))
    .catch(err => console.log(err))
    .finally(() => dispatch(setLoader(false)))
}

export const downloadMongoLoggerCsv = () => () => {
  const url = completeUrl(MONGO_LOGGER_ENDPOINT.endpoint + '/csv')
  return downloadFile(url, 'GET', 0, "Aucun fichier CSV disponible pour aujourd'hui")
}

export const deleteMongoLoggerCsv = () => dispatch => {
  dispatch(setLoader(true))
  return getPayeService()
    .deleteById(MONGO_LOGGER_ENDPOINT, 'csv')
    .then(response => dispatch(setMongoLogger(response)))
    .then(() => dispatch(showAlert('success', 'Fichier CSV supprimé')))
    .catch(err => console.log(err))
    .finally(() => dispatch(setLoader(false)))
}
